"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IssuesApi = void 0;
var _fetchHelpers = require("../util/fetchHelpers");
var _migrationHelpers = require("../util/migrationHelpers");
var _endpointHelpers = require("../util/endpointHelpers");
var _urlExtractors = require("../util/urlExtractors");
var _constants = require("../constants");
var _queryClientUtils = require("../util/queryClientUtils");
const IssuesApi = exports.IssuesApi = (0, _endpointHelpers.createEndpointSdk)(_ref => {
  let {
    api,
    queryClient
  } = _ref;
  return {
    get: id => api.get("issues/".concat(id)).then(_migrationHelpers.IssueMigration.deserialize),
    getAll: function () {
      let searchParams = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return api.getAll("issues".concat((0, _fetchHelpers.getSearchQueryString)(searchParams)), {
        cacheTime: 0
      }) // disable caching
      .then((0, _endpointHelpers.mapResults)(_migrationHelpers.IssueMigration.deserialize));
    },
    batchGet: function () {
      let {
        limit,
        offset,
        sortBy,
        fields,
        filterBy
      } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      const url = "issues:batchGet";
      const requestBody = {};
      if (limit) {
        requestBody.limit = limit;
      }
      if (offset) {
        requestBody.offset = offset;
      }
      if (sortBy) {
        requestBody.sortBy = (0, _fetchHelpers.constructSortParam)(sortBy);
      }
      if (filterBy) {
        const filterParamList = (0, _fetchHelpers.constructFilterParamList)(filterBy);
        for (const [param, value] of filterParamList) {
          // @ts-ignore Once upgraded to TS > 4.1, add a template string type - filter[keyof IssueFilter]
          requestBody[param] = value;
        }
      }
      if (fields) {
        requestBody.fields = fields.join(",");
      }
      return api.batchGet(url, requestBody).then((0, _endpointHelpers.mapResults)(_migrationHelpers.IssueMigration.deserialize));
    },
    create: attributes => api.create("issues", _migrationHelpers.IssueMigration.serialize(attributes)).then(issue => queryClient.setQueryData(["issues", issue.id], issue)).then(_migrationHelpers.IssueMigration.deserialize),
    batchCreate: issues => api.batchCreate("issues:bulk-create", {
      issues: issues.map(_migrationHelpers.IssueMigration.serialize)
    }).then(response => response.map(_migrationHelpers.IssueMigration.deserialize)),
    update: (issueId, attributes) => api.update("issues/".concat(issueId), _migrationHelpers.IssueMigration.serialize(attributes)).then(issue => queryClient.setQueryData(["issues", issue.id], issue)).then(_migrationHelpers.IssueMigration.deserialize),
    delete: _ref2 => {
      let {
        issueId,
        comment
      } = _ref2;
      return api.delete("issues/".concat(issueId).concat(getDeleteSearchQueryParams({
        comment
      })));
    },
    batchDelete: _ref3 => {
      let {
        issueUids,
        comment
      } = _ref3;
      issueUids.forEach(id => queryClient.removeQueries(["issues", id]));
      return api.batchDelete("issues:bulk-delete", {
        comment,
        issueIds: issueUids
      });
    },
    batchUpdate: _ref4 => {
      let {
        issueUids,
        attributes
      } = _ref4;
      issueUids.forEach(id => queryClient.removeQueries(["issues", id]));
      return api.batchUpdate("issues:bulk-patch", {
        issueIds: issueUids,
        updates: _migrationHelpers.IssueMigration.serialize(attributes)
      }).then(response => response.map(_migrationHelpers.IssueMigration.deserialize));
    },
    batchRestore: _ref5 => {
      let {
        issueIds,
        newIssueTypeId
      } = _ref5;
      return api.batchCreate("issues:bulk-restore", {
        issueIds,
        issueSubtypeId: newIssueTypeId
      });
    }
  };
}, {
  invalidateByQueryKeys: (url, method) => {
    const issueId = (0, _urlExtractors.extractIssueId)(url);
    return issueId ?
    // invalidate only single Issue requests
    [["issues", issueId],
    // invalidate all bulk queries in case of changes to the set of Issues
    ...([_constants.HttpMethod.Post, _constants.HttpMethod.Delete].includes(method) ? _queryClientUtils.INVALIDATE_ALL_ISSUES : [])] : _queryClientUtils.INVALIDATE_ALL_ISSUES; // same keys are also in use in createIssueAction
  }
});
const getDeleteSearchQueryParams = _ref6 => {
  let {
    comment
  } = _ref6;
  const params = new URLSearchParams();
  if (comment) {
    params.set("comment", comment);
  }
  if (Array.from(params).length > 0) {
    return "?".concat(params.toString());
  }
  return "";
};
//# sourceMappingURL=IssuesApi.js.map